import parseV0TemplateUrl from "./parseV0TemplateUrl";

/**
 * Used to optimize for cache hits
 */
const parseReactionAssetTemplateUrl = ({
	readUrl,
}: {
	readUrl:
		| {
				v0TemplateUrl?: string | null | undefined;
		  }
		| null
		| undefined;
}) => {
	return parseV0TemplateUrl({
		readUrl,
		aspectRatio: "1x1",
		strategy: "inside",
		size: "xs",
	});
};

export default parseReactionAssetTemplateUrl;
